module.exports = __webpack_public_path__ + "static/media/increaseEngagement.5813959c.svg";